import React, { useState } from "react";
import { editiconorange, rightarrowwhite } from "../../../images";
import TextFieldWithIcon from "../../../components/TextFieldWithIcon/TextFieldWithIcon";
import OtpInput from "react-otp-input";
import CountryCodeDropdown from "../../../components/CountryCodeDropdown/CountryCodeDropdown";
import { useWindowSize } from "react-use";

import Joi from "joi";
import http from "../../../helpers/http";
import { useAuth } from "../../../context/Auth/AuthState";
import config from "../../../config/config";
import { toast } from "react-toastify";
import ToastMsg from "../../../components/ToastMsg/ToastMsg";
import useTheme from "../../../components/useTheme/useTheme";

const EditWhatsapp = ({ lightTheme }) => {
  // =============== VARIABLE & STATES  ===========================
  const { theme } = useTheme();
  const { width } = useWindowSize();
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [formError, setFormError] = useState({});
  const [otpVal, setOtpVal] = useState("");
  const [isWASame, setIsWASame] = useState(false);
  const [codes, setCodes] = useState([]);
  const [waCountryCode, setWaCountryCode] = useState({
    name: "India",
    iso3: "IND",
    phone_code: "91",
  });
  const [values, setValues] = useState({
    whatsapp_no: "",
    whatsapp_country_code: "91",
  });
  const [visibility, setVisibility] = useState({
    form: true,
    otp: false,
  });

  const auth = useAuth();
  const joiOptions = config.joiOptions;
  const base_url = config.api_url; //without trailing slash

  // =============== FUNCTIONS  ===========================

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "whatsapp_no") {
      if (!/^\d*$/.test(value)) return; // allow digits only
      if (value.length > 10) return; // max 10 digits
    }

    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSelectChange = (value, fieldName) => {
    setValues((prevState) => {
      return {
        ...prevState,
        [fieldName]: value,
      };
    });
  };

  const handleWAChange = (e) => {
    const { checked } = e.target;

    if (checked) {
      setValues((prevState) => {
        return {
          ...prevState,
          whatsapp_no: auth?.user?.phone || "",
          whatsapp_country_code: auth?.user?.country_code || "91",
        };
      });

      setWaCountryCode({
        name: "India",
        iso3: "IND",
        phone_code: auth?.user?.country_code || "91",
      });

      setIsWASame(true);
    } else {
      setValues((prevState) => {
        return {
          ...prevState,
          whatsapp_no: "",
          whatsapp_country_code: "91",
        };
      });
      setWaCountryCode({
        name: "India",
        iso3: "IND",
        phone_code: "91",
      });

      setIsWASame(false);
    }
  };

  const handleotpChange = (otp) => {
    setOtpVal(otp);
  };

  const validate = async (data) => {
    const schemaObj = {
      whatsapp_country_code: Joi.string().trim().required().label("Code"),
      whatsapp_no: Joi.string()
        .pattern(/^\d+$/)
        .length(10)
        .required()
        .label("Whatsapp Number")
        .messages({
          "string.empty": "WhatsApp number is required",
          "string.pattern.base": "WhatsApp number must contain digits only",
          "string.length": "WhatsApp number must be exactly 10 digits",
        }),
    };

    const schema = Joi.object(schemaObj).options({ allowUnknown: true });

    const { error } = schema.validate(data, joiOptions);
    const errors = {};

    if (error) {
      error.details.forEach((field) => {
        errors[field.path[0]] = field.message;
      });
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let errors = await validate(values);

    setFormError(errors);
    if (Object.keys(errors).length) {
      return;
    }

    const data = await http.post(
      base_url + "/business/edit-whatsapp/" + auth?.user?._id,
      values
    );

    if (data) {
      setVisibility({
        form: false,
        otp: true,
      });
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    let errors = await validate(values);

    setFormError(errors);
    if (Object.keys(errors).length) {
      return;
    }

    const data = await http.post(
      base_url + "/business/edit-whatsapp-verify/" + auth?.user?._id,
      { ...values, otp: otpVal }
    );

    if (data) {
      const updatedUserData = await http.get(
        base_url + "/business/edit-profile/" + auth?.user?._id
      );
      if (updatedUserData) {
        auth.refresh(updatedUserData?.data?.data);
        localStorage.setItem(config.jwt_auth_key, updatedUserData?.data?.token);
        setVisibility({
          form: false,
          otp: false,
        });
        setIsEditClicked(false);
        toast(
          <ToastMsg message="Your detail is updated" />,
          config.success_toast_config
        );
      }
    }
  };

  const handlresendotp = async (e) => {
    const { data } = await http.post(
      base_url + "/business/edit-whatsapp/" + auth?.user?._id,
      values
    );

    if (data) {
      setOtpVal("");
      toast(<ToastMsg message="OTP reshared" />, config.success_toast_config);
    }
  };

  // =============== DATA FETCHING  ===========================
  const fetchCodes = async () => {
    const { data } = await http.get(base_url + "/general/countries/codes");

    if (data) {
      setCodes(data);
    }
  };

  // =============== SIDE EFFECTS  ===========================
  React.useEffect(() => {
    fetchCodes();
  }, []);

  React.useEffect(() => {
    if (isWASame) {
      setValues((prev) => ({
        ...prev,
        whatsapp_no: auth?.user?.phone || "",
        whatsapp_country_code: auth?.user?.country_code || "91",
      }));
      setWaCountryCode({
        name: "India",
        iso3: "IND",
        phone_code: auth?.user?.country_code || "91",
      });
    }
  }, [auth?.user?.phone, auth?.user?.country_code, isWASame]);

  return (
    <>
      <div className="field_wrapper padding_left">
        <div className="row">
          <div className="col-4 col-sm-4 col-md-4 ps-0">
            <div className="field_wrapper_1">
              <CountryCodeDropdown
                textLabel="Code*"
                readOnly
                data={codes}
                value={{
                  name: "India",
                  iso3: "IND",
                  phone_code: auth?.user?.whatsapp_country_code || "91",
                }}
                lightTheme={lightTheme}
              />
            </div>
          </div>
          <div
            className={`col-8 col-sm-8 col-md-8 ${
              width > 992 ? "pe-0" : "p-0"
            }`}
          >
            <div className="field_wrapper_1">
              <TextFieldWithIcon
                label="WhatsApp number*"
                icon={editiconorange}
                disabled={isEditClicked}
                onClick={() => {
                  setIsEditClicked(true);
                  setVisibility({ form: true, otp: false });
                  setValues({
                    whatsapp_no: "",
                    whatsapp_country_code:
                      auth?.user?.whatsapp_country_code || "91",
                  });
                  setWaCountryCode({
                    name: "India",
                    iso3: "IND",
                    phone_code: auth?.user?.whatsapp_country_code || "91",
                  });
                  setOtpVal("");
                  setIsWASame(false);
                  setFormError({});
                }}
                value={auth?.user?.whatsapp_no || ""}
                InputProps={{
                  readOnly: true,
                }}
                lightTheme={lightTheme}
              />
            </div>
          </div>
        </div>

        {isEditClicked && visibility?.form && (
          <>
            <form onSubmit={handleSubmit}>
              <div className="field_wrapper">
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 ps-0">
                    <div className="field_wrapper_1">
                      <CountryCodeDropdown
                        textLabel="Code*"
                        data={codes}
                        onChange={(e, value) => {
                          handleSelectChange(
                            value.phone_code,
                            "whatsapp_country_code"
                          );
                          setWaCountryCode(value);
                        }}
                        value={waCountryCode}
                        lightTheme={lightTheme}
                      />
                    </div>
                  </div>
                  <div
                    className={`col-8 col-sm-8 col-md-8 ${
                      width > 992 ? "pe-0" : "p-0"
                    }`}
                  >
                    <div className="field_wrapper_1">
                      <TextFieldWithIcon
                        label="WhatsApp number*"
                        // icon={editiconorange}
                        name="whatsapp_no"
                        value={values.whatsapp_no}
                        onChange={handleChange}
                        lightTheme={lightTheme}
                      />
                    </div>
                  </div>
                </div>
                <p className="error">{formError.whatsapp_no}</p>
              </div>

              <div className="checkbox_wrapper">
                <label
                  className={`checkbox_label ${
                    theme === "dark" && "text-white"
                  }`}
                >
                  <input
                    type="checkbox"
                    className="check_box"
                    checked={isWASame}
                    onChange={handleWAChange}
                  />
                  Same as phone number
                </label>
              </div>

              <p className={`pass_notice ${theme === "dark" && "text-white"}`}>
                Please enter your new 10 digit WhatsApp number.
                <br />
                An OTP verification will be sent to your new WhatsApp number.
              </p>

              <div className="mobile_center">
                <div className="btn_wrapper">
                  <button
                    className={`form_btn ${theme === "dark" && "text-white"}`}
                  >
                    Verify with OTP
                    <img
                      src={rightarrowwhite}
                      alt="icon"
                      className="icon"
                      loading="lazy"
                      style={{
                        filter: theme === "light" ? "invert(1)" : "invert(0)",
                      }}
                    />
                  </button>
                  <button
                    type="button"
                     className={`back_button ${
                      theme === "dark" && "text-white"
                    }`}
                    onClick={() => {
                      setIsEditClicked(false);
                      setValues({
                        whatsapp_no: "",
                        whatsapp_country_code:
                          auth?.user?.whatsapp_country_code || "91",
                      });
                      setWaCountryCode({
                        name: "India",
                        iso3: "IND",
                        phone_code: auth?.user?.whatsapp_country_code || "91",
                      });
                      setOtpVal("");
                      setIsWASame(false);
                      setFormError({});
                      setVisibility({ form: true, otp: false });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </>
        )}
        {isEditClicked && visibility?.otp && (
          <>
            <div className="otp_wrapper">
              <div className={`otp_title ${theme === "light" && "text-black"}`}>
                Enter OTP
              </div>
              <div className="otp_box_wrapper">
                <OtpInput
                  value={otpVal}
                  onChange={handleotpChange}
                  numInputs={6}
                  containerStyle="otp_input_wrapper"
                  inputStyle={
                    theme === "dark" ? "otp_input" : "otp_input text-black"
                  }
                  isInputNum={true}
                  focusStyle={
                    theme === "dark" ? "otp_focused" : "otp_focused_light_mode"
                  }
                  shouldAutoFocus
                  lightTheme={lightTheme}
                />
              </div>
              <div className="mobile_center">
                <div className="btn_wrapper">
                  <button
                    className={`form_btn ${theme === "dark" && "text-white"}`}
                    onClick={handleOtpSubmit}
                  >
                    Verify
                    <img
                      src={rightarrowwhite}
                      alt="icon"
                      className="icon"
                      loading="lazy"
                      style={{
                        filter: theme === "light" ? "invert(1)" : "invert(0)",
                      }}
                    />
                  </button>
                  <button
                    className={`back_button ${
                      theme === "dark" && "text-white"
                    }`}
                    onClick={handlresendotp}
                  >
                    Resend OTP
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditWhatsapp;
